/**
 * Email templates used when sending from the app.
 * Edit the strings here; no backend deploy needed. Rebuild/redeploy the frontend to see changes.
 *
 * Use {{variableName}} for substitution, e.g. {{customerName}}, {{invoiceNumber}}.
 */

function substitute(str, variables) {
  if (typeof str !== 'string') return str;
  if (!variables || typeof variables !== 'object') return str;
  return str.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    variables[key] != null ? String(variables[key]) : ''
  );
}

// Format a full name like "BEN DICKINSON" into "Ben"
function formatFirstName(name) {
  if (!name) return '';
  const raw = String(name).trim();
  if (!raw) return '';
  const first = raw.split(/\s+/)[0].replace(/[^A-Za-z'-]/g, '');
  if (!first) return '';
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}

const TEMPLATES = {
  invoice: {
    subject: 'Invoice {{invoiceNumber}} from 8|7',
    bodyText: `Dear {{customerName}},

Please find attached your invoice {{invoiceNumber}}.

Thank you for your business!

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Dear {{customerName}},</p>
    <p>Please find attached your invoice {{invoiceNumber}}.</p>
    <p>Thank you for your business!</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  },
  quote: {
    subject: 'Quote {{quoteNumber}} from 8|7',
    bodyText: `Dear {{customerName}},

Please find attached your quote {{quoteNumber}}.

This quote is valid for 30 days from {{createdAt}}.

Thank you for your interest in our services!

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Dear {{customerName}},</p>
    <p>Please find attached your quote {{quoteNumber}}.</p>
    <p>This quote is valid for 30 days from {{createdAt}}.</p>
    <p>Thank you for your interest in our services!</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  },

  order_start: {
    subject: "We're on it! Order {{orderNumber}} is in the works",
    bodyText: `Whoohoo! Let's get these shirts going.

We've got your order ({{orderNumber}}) and we're on it. Follow along to watch the progress here:

{{trackingUrl}}

Thanks for choosing 8|7!

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Whoohoo! Let's get these shirts going.</p>
    <p>We've got your order ({{orderNumber}}) and we're on it. <a href="{{trackingUrl}}">Follow along here</a> to watch the progress.</p>
    <p>Thanks for choosing 8|7!</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  },

  shirts_here: {
    subject: "Your blank garments are in — printing is next (Order {{orderNumber}})",
    bodyText: `Great news – the blank garments for your order ({{orderNumber}}) have arrived at our shop.

Our team is now moving into the print stage. Give us a few more days to complete printing, and you can check progress anytime here:

{{trackingUrl}}

Thanks,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Great news – the blank garments for your order ({{orderNumber}}) have arrived at our shop.</p>
    <p>Our team is now moving into the print stage. Give us a few more days to complete printing, and <a href="{{trackingUrl}}">check progress here</a> anytime.</p>
    <p>Thanks,<br>8|7 Team</p>
  </body>
</html>`
  },

  all_done: {
    subject: "Your order {{orderNumber}} is complete!",
    bodyText: `You're all set! Order {{orderNumber}} is done and ready.

 We have a handful of garments waiting for you up front! Thanks for your business – we hope you love the shirts!

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>You're all set! Order {{orderNumber}} is done and ready.</p>
    <p>We have a handful of garments waiting for you up front! Thanks for your business – we hope you love the shirts!</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  },

  order_shipped: {
    subject: "Tracking for order {{orderNumber}}",
    bodyText: `Hi {{customerName}},

Your order {{orderNumber}} has shipped.

Carrier: {{carrier}}
Tracking Number: {{trackingNumber}}
Tracking Link: {{trackingUrl}}

Thanks for choosing 8|7!

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Hi {{customerName}},</p>
    <p>Your order <strong>{{orderNumber}}</strong> has shipped.</p>
    <p>
      Carrier: <strong>{{carrier}}</strong><br />
      Tracking Number: <strong>{{trackingNumber}}</strong><br />
      Tracking Link: <a href="{{trackingUrl}}">{{trackingUrl}}</a>
    </p>
    <p>Thanks for choosing 8|7!</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  },

  follow_up_review: {
    subject: "Quick check-in from Ben – how did everything look?",
    bodyText: `Hey {{customerName}},

It's Ben – just checking in to make sure everything looked good with your order ({{orderNumber}}). Let me know if you had any issues or anything we can improve on.

We're a small business and we thrive on honest (and hopefully good!) Google reviews. If you'd like to leave a review, I'd gladly send you an 8|7 swag box as a thank-you – just reply to this email after you've left one and we'll get you hooked up.

Leave a review here: https://g.page/r/Car3zvoCPUJ7EAE/review

Thanks again,

Ben`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Hey {{customerName}},</p>
    <p>It's Ben – just checking in to make sure everything looked good with your order ({{orderNumber}}). Let me know if you had any issues or anything we can improve on.</p>
    <p>We're a small business and we thrive on honest (and hopefully good!) Google reviews. If you'd like to leave a review, I'd gladly send you an 8|7 swag box as a thank-you – just reply to this email after you've left one and we'll get you hooked up.</p>
    <p><a href="https://g.page/r/Car3zvoCPUJ7EAE/review">Leave a review here</a></p>
    <p>Thanks again,</p>
    <p>Ben</p>
  </body>
</html>`
  },

  reorder_reminder: {
    subject: "Almost annual reorder time - 5% off",
    bodyText: `Hi {{customerName}},

It's been almost a year since your last order with us.

If you need an annual reorder, just reply to this email and we'll get it started. As a thank-you, we'll apply 5% off this year's reorder.

Best regards,
8|7 Team`,
    bodyHtml: `<html>
  <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
    <p>Hi {{customerName}},</p>
    <p>It's been almost a year since your last order with us.</p>
    <p>If you need an annual reorder, just reply to this email and we'll get it started. As a thank-you, we'll apply <strong>5% off</strong> this year's reorder.</p>
    <p>Best regards,<br>8|7 Team</p>
  </body>
</html>`
  }
};

/**
 * Get filled-in subject, text, and html for a template.
 * @param {string} templateId - 'invoice' | 'quote' | 'order_start' | 'shirts_here' | 'all_done' | 'order_shipped' | 'follow_up_review' | 'reorder_reminder'
 * @param {Object} variables - e.g. { customerName, orderNumber, trackingUrl }
 */
export function getEmailContent(templateId, variables = {}) {
  const t = TEMPLATES[templateId];
  if (!t) return null;
  const vars = { ...variables };
  if (vars.customerName) {
    vars.customerName = formatFirstName(vars.customerName);
  }
  return {
    subject: substitute(t.subject, vars),
    text: substitute(t.bodyText, vars),
    html: substitute(t.bodyHtml, vars)
  };
}

export { TEMPLATES };
